import { call, put, select } from "redux-saga/effects";
import { selectUserCredentials } from "../../../state/userCredential/userCredentialSlice";
import { loadNotifications, setNotificationsEnabled } from "../../../state/notification/notificationSlice";
import { getNotifications } from "../../../browser/storage";

export function* loadNotificationsSaga() {
  try {
    const { uid } = yield select(selectUserCredentials);
    if (!uid) return;

    const saved = yield call(getNotifications, uid);

    const { list = [], enabled = true } = saved || {};

    yield put(loadNotifications(list));
    yield put(setNotificationsEnabled(enabled));

  } catch (err) {
    console.error("Failed to load notifications:", err);
  }
}